<ul class="list">
    <h3 class="text-center" *ngIf="!environment.production">Staging Environment</h3>
    <li>
        <a routerLink="/calendar" routerLinkActive="active-link">
            <span class="icon"><fa-icon [icon]="faCalendarWeek"></fa-icon></span>
            Driver's Calendar
        </a>
    </li>

    <li *ngIf="permissions.includes('appointments')">
        <a routerLink="/appointments" routerLinkActive="active-link">
            <span class="icon"><fa-icon [icon]="faCalendarCheck"></fa-icon></span>
            Appointments
        </a>
    </li>
    <li *ngIf="permissions.includes('companies')">
        <a routerLink="/companies" routerLinkActive="active-link">
            <span class="icon"><fa-icon [icon]="faBuilding"></fa-icon></span>
            Companies
        </a>
    </li>
    <li *ngIf="permissions.includes('passengers')">
        <a routerLink="/users" routerLinkActive="active-link">
            <span class="icon"><fa-icon [icon]="faUsers"></fa-icon></span>
            Users
        </a>
    </li>
    <li *ngIf="permissions.includes('providers')">
        <a routerLink="/providers" routerLinkActive="active-link">
            <span class="icon"><fa-icon [icon]="faAddressCard"></fa-icon></span>
            Providers
        </a>
    </li>
    <li *ngIf="permissions.includes('senior_centers')">
        <a routerLink="/senior-centers" routerLinkActive="active-link">
            <span class="icon"><fa-icon [icon]="faHotel"></fa-icon></span>
            Senior Centers
        </a>
    </li>
    <li *ngIf="permissions.includes('services')">
        <a routerLink="/services" routerLinkActive="active-link">
            <span class="icon"><fa-icon [icon]="faHandHoldingHeart"></fa-icon></span>
            Services
        </a>
    </li>
    <li *ngIf="permissions.includes('call_log')">
        <a routerLink="/call-log" routerLinkActive="active-link">
            <span class="icon"><fa-icon [icon]="faPhone"></fa-icon></span>
            Call Log
        </a>
    </li>
    <li *ngIf="permissions.includes('users')">
        <a routerLink="/admin-users" routerLinkActive="active-link">
            <span class="icon"><fa-icon [icon]="faUsers"></fa-icon></span>
            Admin Users
        </a>
    </li>

    <li>
        <a routerLink="/reports" routerLinkActive="active-link">
            <span class="icon"><fa-icon [icon]="faChartBar"></fa-icon></span>
            Reports
        </a>
    </li>
    
    <li *ngIf="permissions.includes('kpi_data')">
        <a routerLink="/kpi-data-entry" routerLinkActive="active-link">
            <span class="icon"><fa-icon [icon]="faTable"></fa-icon></span>
            KPI Data Entry
        </a>
    </li>
    <li *ngIf="permissions.includes('administrative')">
        <a routerLink="/administrative" routerLinkActive="active-link">
            <span class="icon"><fa-icon [icon]="faCog"></fa-icon></span>
            Administrative
        </a>
    </li>
</ul>